const PermissionKey = Object.freeze({
    UserAdministrator: 'userAdministrator',
    Billing: 'billing',
    TinyPumper: 'tinyPumper',
    Demo: 'demo',
    Experimental: 'experimental',
    GearUp: 'gearUp'
});

export { PermissionKey };
